import React, { useEffect, useState } from "react";
import Layout from "../components/layout/Layout";
import AllTeams from "../components/team/AllTeams";
import Modal from "../components/ui/Modal";
import { useDispatch, useSelector } from "react-redux";
import { teamsApi, useAddTeamMutation } from "../features/teams/teamsApi";
import Error from "../components/ui/Error";
import debounceHandler from "../utils/debounceHandler";

export default function Team() {
    const { user } = useSelector((state) => state.auth) || {};
    const dispatch = useDispatch();
    const [addTeam, { isSuccess: isAddTeamSuccess }] = useAddTeamMutation();

    const [teamModal, setTeamModal] = useState(false);

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [color, setColor] = useState("");

    const [error, setError] = useState("");
    const [nameError, setNameError] = useState("");

    const teamModalOpen = () => setTeamModal(true);
    const teamModalClose = () => setTeamModal(false);

    useEffect(() => {
        setName("");
        setDescription("");
        setColor("");
        setColor("");
    }, [isAddTeamSuccess]);

    const doSearch = (value) => {
        setNameError("");
        // check team name in database
        setName(value);

        dispatch(teamsApi.endpoints.getTeam.initiate(value))
            .unwrap()
            .then((data) => {
                if (data.length > 0) {
                    setNameError("Team name is already exists");
                }
            })
            .catch((err) => {});
    };

    const handleSearch = debounceHandler(doSearch, 500);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError("");
        setNameError("");

        if (!name) {
            setError("Team name is required!!");
            return;
        }
        if (!description) {
            setError("Team description is required!!");
            return;
        }

        const data = {
            name,
            description,
            color,
            user,
            timestamp: new Date().getTime(),
        };

        if (!nameError) addTeam(data);
        teamModalClose();
    };

    return (
        <Layout>
            <div className="px-10 mt-6 flex justify-between">
                <h1 className="text-2xl font-bold">Teams</h1>
                <button
                    onClick={teamModalOpen}
                    className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
                >
                    <svg
                        className="w-5 h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                    </svg>
                </button>
            </div>
            <AllTeams />
            {teamModal && (
                <Modal open={teamModal} close={teamModalClose} title="Add Team">
                    <form className="space-y-3" onSubmit={handleSubmit}>
                        {error && <Error message={error} />}
                        <div>
                            <label
                                htmlFor="name"
                                className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Name
                            </label>
                            <input
                                type="text"
                                id="name"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-200 focus:border-blue-300 block w-full p-1.5"
                                placeholder="Name"
                                // value={name}
                                onChange={(e) => handleSearch(e.target.value)}
                            />
                            {nameError && (
                                <span className="text-red-600">
                                    {nameError}
                                </span>
                            )}
                        </div>

                        <div>
                            <label
                                htmlFor="description"
                                className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Description
                            </label>
                            <input
                                type="text"
                                id="description"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-200 focus:border-blue-300 block w-full p-1.5"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="color"
                                className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Color (Valid name or Hex code e.g #fff)
                            </label>
                            <input
                                type="text"
                                id="color"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-200 focus:border-blue-300 block w-full p-1.5"
                                placeholder="Valid name or hex color code e.g #22c55e"
                                value={color}
                                onChange={(e) => setColor(e.target.value)}
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={nameError}
                            className="w-full text-white bg-slate-700 hover:bg-slate-800 focus:ring-2 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                        >
                            Save
                        </button>
                    </form>
                </Modal>
            )}
        </Layout>
    );
}
